document.addEventListener('turbolinks:load', function () {
  // Animate elements when they enter the viewport
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-slide-in');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.slide-in-trigger').forEach(el => observer.observe(el));

  // Section element references
  const sections = [
    { header: document.getElementById("header-faq"), section: document.getElementById("faqSection") },
    { header: document.getElementById("electronicVotingHeader"), section: document.getElementById("electronicVotingSection") },
    { header: document.getElementById("proxySystemHeader"), section: document.getElementById("proxySystemSection") },
    { header: document.getElementById("annualElectionGuide"), section: document.getElementById("annualElectionGuideSection") },
    { header: document.getElementById("electionByAcclamationGuide"), section: document.getElementById("electionByAcclamationSection") },
    { header: document.getElementById("changeInGoverningDocumentsGuide"), section: document.getElementById("changeInGoverningDocumentsSection") },
    { header: document.getElementById("recallGuide"), section: document.getElementById("recallGuideSection") }
  ];

  const scrollToTopBtn = document.getElementById("scrollToTop");

  // Toggle FAQ answer visibility
  document.querySelectorAll(".faq-header").forEach(header => {
    header.addEventListener("click", () => {
      const answer = header.nextElementSibling;
      const icon = header.querySelector(".toggle-icon");
      if (!answer) return;

      const isOpen = answer.style.maxHeight;
      answer.style.maxHeight = isOpen ? null : answer.scrollHeight + "px";
      icon.textContent = isOpen ? "+" : "−";
    });
  });

  // Show scroll-to-top button when scrolling past a section
  window.addEventListener("scroll", () => {
    if (!scrollToTopBtn) return;

    const shouldShow = sections.some(({ section, header }) => {
      if (section && header) {
        const secRect = section.getBoundingClientRect();
        const headRect = header.getBoundingClientRect();
        return secRect.top < window.innerHeight && secRect.bottom > 0 && headRect.bottom < 0;
      }
      return false;
    });

    scrollToTopBtn.classList.toggle("hidden", !shouldShow);
  });

  // Scroll to the first visible section in order of preference
  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener("click", () => {
      for (const { header } of sections) {
        if (header) {
          header.scrollIntoView({ behavior: "smooth" });
          break;
        }
      }
    });
  }
});
